/* eslint-disable unicorn/filename-case */

export { getServerSideProps } from 'views/stores/get-server-side-props'
export { StoresPage as default } from 'views/stores/StoresPage'
